const forty = [
  {
    name: 'all-regions',
    type: '40',
    size: '40px'
  },
  {
    name: 'africa',
    type: '40',
    size: '40px'
  },
  {
    name: 'asia',
    type: '40',
    size: '40px'
  },
  {
    name: 'europe',
    type: '40',
    size: '40px'
  },
  {
    name: 'north-america',
    type: '40',
    size: '40px'
  },
  {
    name: 'oceania',
    type: '40',
    size: '40px'
  },
  {
    name: 'south-america',
    type: '40',
    size: '40px'
  }
];

export default forty;


// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/forty.js